import { secureGet } from '../../utils/HttpUtils';

export const getInformationMessagesService = () => {
  return new Promise((resolve) => {
    secureGet('/api/bff-notification/private/information-messages', {})
      .then((data) => resolve(data))
      .catch(() => resolve({ data: [] }));
  });
};
